import { z } from 'zod';

/**
 * Validation schema for dates in member creation
 */
export const dateValidationSchema = z.object({
  billingDate: z.string({
    required_error: "billingDate is required",
    invalid_type_error: "billingDate must be a string in MM/DD/YYYY format"
  })
    .min(1, "billingDate is required")
    .refine(
      (date) => {
        // Check if billing date is today or in the future
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const billingDate = new Date(date);
        return billingDate >= today;
      },
      { message: "billingDate must be today or in the future" }
    ),
  effectiveDate: z.string({
    required_error: "effectiveDate is required",
    invalid_type_error: "effectiveDate must be a string in MM/DD/YYYY format"
  })
    .min(1, "effectiveDate is required")
    .refine(
      (date) => {
        // Check if effective date is on the 1st of a month
        const effectiveDate = new Date(date);
        return effectiveDate.getDate() === 1;
      },
      { message: "effectiveDate must be on the 1st of a month" }
    )
}).refine(
  (data) => {
    // Check that billing date is before effective date
    const billingDate = new Date(data.billingDate);
    const effectiveDate = new Date(data.effectiveDate);
    return billingDate < effectiveDate;
  },
  {
    message: "billingDate must be before effectiveDate",
    path: ["billingDate"]
  }
);